import Vue from 'vue';
import Vuex from 'vuex';
import UserModule from '@/store/modules/user';
import ThemeModule from '@/store/modules/theme';
import BusinessProcessModule from '@/store/modules/business-process';
import SnackbarModule from '@/store/modules/snackbar';
import AppBarsModule from '@/store/modules/app-bars';
import EmailSignatureModule from '@/store/modules/email-signature';
import ReferenceDataModule from '@/store/modules/reference-data';
import SmtpModule from '@/store/modules/smtp';
import SummaryViewModule from '@/store/modules/summary-view';
import ContactManagementModule from '@/store/modules/contact-management';
import AvatarsModule from '@/store/modules/avatars';
import ResourcesModule from '@/store/modules/resources';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    USER: UserModule,
    AVATARS: AvatarsModule,
    CONTACT_MANAGEMENT: ContactManagementModule,
    THEME: ThemeModule,
    BUSINESS_PROCESS: BusinessProcessModule,
    SNACKBAR: SnackbarModule,
    APP_BARS: AppBarsModule,
    EMAIL_SIGNATURE: EmailSignatureModule,
    REFERENCE_DATA: ReferenceDataModule,
    SMTP: SmtpModule,
    SUMMARY_VIEW: SummaryViewModule,
    RESOURCES: ResourcesModule
  }
});
